import React, { PureComponent } from "react";
import HelpIconButtonWithTooltip from "../../../ui-building-blocks/icons/HelpIconButtonWithTooltip";
import Teams from "../../../../api/Teams";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

class Utilization extends PureComponent {
  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    const val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  }

  getHumanResources(team_id) {
    return (this.getDataValue(team_id, "Human Utilization") * 100).toFixed(0);
  }

  getMachineFacility(team_id) {
    return (this.getDataValue(team_id, "Machine Utilization") * 100).toFixed(0);
  }

  get blockHeight() {
    const { teams } = this.props;
    const c = Object.keys(teams).length;
    const h = 152 + 34 * c;

    return h < 330 ? 330 : h;
  }

  render() {
    const { teams } = this.props;
    const colors = Teams.competitiveColors();

    return (
      <div className="col-md-3 col-xs-12">
        <div
          className="bg-white p-30 mh-330"
          style={{ height: this.blockHeight }}
        >
          <h5>
            UTILIZATION
            <HelpIconButtonWithTooltip
              category="Utilization"
              tooltipContent="This section displays your labor and machine hour utilization (i.e. actual hours divided by ideal hours)."
              iconSize="sm"
            />
          </h5>
          <hr />
          <div className="panel-dashboard-white mt-30">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <span>Team</span>
                    </th>
                    <th>
                      <span>Human Resources</span>
                    </th>
                    <th>
                      <span>Machine & Facility</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(teams).map((team_id, index) => {
                    const squareStyle = {
                      display: "inline-block",
                      width: 15,
                      height: 15,
                      backgroundColor: colors[index % colors.length]
                    };
                    const tooltipElement = (
                      <Tooltip id={`tooltip-${team_id}`}>
                        {teams[team_id]}
                      </Tooltip>
                    );

                    return (
                      <tr className="text-center" key={team_id}>
                        <th>
                          <OverlayTrigger
                            placement="top"
                            overlay={tooltipElement}
                          >
                            <span style={squareStyle} />
                          </OverlayTrigger>
                        </th>
                        <td>{this.getHumanResources(team_id)}%</td>
                        <td>{this.getMachineFacility(team_id)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Utilization;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/utilization.js